import _ from 'underscore';

const optimizelyLocal = {

  trackEvent(eventName, eventPathName) {
    const windowPathName = window.location.pathname;
    if (eventPathName === windowPathName) {
      const optimizely = window.optimizely || [];
      optimizely.push(['trackEvent', eventName]);
    }
  },

  pushEvent(eventName) {
    const optimizely = window.optimizely || [];
    optimizely.push(['trackEvent', eventName]);
  },

  allocateEvents(optimizelyEvents, optimizelyUrls) {
    _.each(optimizelyEvents, (optimizelyEvent) => {
      if (optimizelyUrls !== false) {
        _.each(optimizelyUrls, (optimizelyUrl) => {
          optimizelyLocal.trackEvent(optimizelyEvent, optimizelyUrl);
        });
      } else {
        optimizelyLocal.pushEvent(optimizelyEvent);
      }
    });
  },
};

export default optimizelyLocal;

